import { portalFetch } from "@/lib/portalApi";
import { useQuery } from "@tanstack/react-query";

export type SparkCredential = {
  id: string;
  bqProjectId: string;
  datasets: string[];
  readerServiceAccount: string | null;
  secretName: string;
  createdAt: string;
  updatedAt: string;
};

export type SparkConfig = {
  sparkEnabled: boolean;
  effectiveEnabled: boolean;
  credentials: SparkCredential[];
  sparkDashboardCount: number;
};

/** Super-admin view of a tenant's SimplySpark setup. Read-only. */
export function useSparkConfig(tenantId: string | null) {
  return useQuery({
    queryKey: ["portal-spark-config", tenantId],
    queryFn: () => portalFetch<SparkConfig>(`/api/portal/tenants/${tenantId}/spark/config`),
    enabled: !!tenantId,
  });
}
